import { Component, EventEmitter, OnInit, Input, SimpleChanges, OnChanges, Output, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Message, Thread } from 'app/messages/message-service/message.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { Contact } from 'app/models/dto/contact.model';

@Component({
  selector: 'app-inbox-email-message',
  templateUrl: './inbox-email-message.component.html',
  styleUrls: ['./inbox-email-message.component.scss'],
  standalone: false
})
export class InboxEmailMessageComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() message: Message;
  @Input() thread: Thread;
  @Input() isLast: boolean;
  @Input() borrower: Borrower;
  @Input() joinedContacts: Contact[];
  @Output() handleEmailCreate = new EventEmitter();
  @Output() scrollIntoView = new EventEmitter();

  @ViewChild('lastMessageFocus') lastMessageFocus: ElementRef;

  firstName: string = 'Un';
  lastName: string = 'Known';
  isLendion: boolean = true;
  messageCreateTypeValue: string = '';

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.message && !!this.message) {
      this.splitName(this.message.fromName ?? null);
      this.checkIfLendion(this.message.fromEmail ?? null);
      this.findReadMessage(this.message);
    }
  }

  ngAfterViewInit(): void {
    if (this.isLast) {
      this.scrollIntoView.emit(this.lastMessageFocus.nativeElement.scrollHeight);
    }
  }

  splitName(fromName: string | null): void {
    if (!!fromName) {
      this.firstName = fromName.split(' ').slice(0, -1).join(' ');
      this.lastName = fromName.split(' ').slice(-1).join(' ');
    }
  }

  checkIfLendion(fromEmail: string | null): void {
    if (!!fromEmail) {
      this.isLendion = !!(fromEmail.includes('lendio'));
    }
  }

  findReadMessage(message: Message) {
      message.recipientRecords ?
        _.map(message.recipientRecords, (recipient: any) => {
          if (recipient.opens) {
            message.opened = true;
            message.numberOfViews ? message.numberOfViews++ : message.numberOfViews = 1;
          } else {
            message.opened = false;
          }
        }) : message.opened = false;
  }

  setMessageCreateType(value: string) {
    this.messageCreateTypeValue = value;
  }

  downloadAttachment(attachmentId: number): void {
    const url = `${environment.API_URL}/document/${attachmentId}?stream=1&method=attachment`;
    window.location.href = url;
  }

  ngOnDestroy(): void {
    this.messageCreateTypeValue = '';
  }
}
